import { GlobalController } from 'src/shared/global/GlobalController'
import InvoiceReceivedCompetenceReport from './InvoiceReceivedCompetenceReport.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'invoice-received-competence',
    name:
      'invoiceReceivedCompetence',
    component: InvoiceReceivedCompetenceReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
